// Sidebar.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { WSREST_TABATA, SITE, NOME_APP } from '../../config';
import { getMerlinoT } from '../../services/merlinoService';

async function fetchMenuUtente() {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let t = getMerlinoT('mT');
        headers.append('Authorization', 'Bearer ' + t);

        let urlServizio = WSREST_TABATA + 'tabusers/menu/abilitato/' + SITE + '/' + NOME_APP + '/it';

        fetch(urlServizio, {
            method: 'GET',
            headers: headers,
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    reject(res.status);
                    throw new Error(res.status);
                }
            })
            .then((json) => {
                resolve(json);
            });
    });
}

function Sidebar() {
    const [collapsed, setCollapsed] = useState(false);

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
        document.body.classList.toggle('sidebar-collapsed'); // o applica classi specifiche
    };

    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        // Fetch menu items on component mount
        fetchMenuUtente()
            .then((response) => {
                setMenuItems(response);
            })
            .catch((error) => {
                console.error('Error fetching menu items:', error);
            });
    }, []);

    return (
        <div className="sidebar sidebar-dark sidebar-main sidebar-expand-lg">
           <div className="sidebar-section">
                <div className="sidebar-section-body d-flex justify-content-center">
				    <h5 className="sidebar-resize-hide flex-grow-1 my-auto">Menu</h5>
                    <div>
                        <button onClick={toggleSidebar} type="button" className="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex">
                            <i className="ph-arrows-left-right"></i>
                        </button>
                        <button type="button" className="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none">
                            <i className="ph-x"></i>
                        </button>
				    </div>
			    </div>
            </div>
            <div className="sidebar-section {`sidebar ${collapsed ? 'collapsed' : ''}`}">
                <ul className="nav nav-sidebar" data-nav-type="accordion">
                    {menuItems.map((item) => (
                        <li className="nav-item" key={item.menu}>
                            <a href={item.url} className="nav-link">
                                <i className="ph-house"></i>
                                <span>{item.descrizione}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Sidebar;



